var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",on:{"click":_vm.OnClick}},[_vm._v("\n\t"+_vm._s(_vm.loading ? '加载中...' : '点击加载更多')+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }